export const acceptedContactTypesOptions = [
  { key: 'SPOUSE', label: 'Spouse / Partner' },
  { key: 'CHILD', label: 'Child' },
  { key: 'FRIEND', label: 'Friend' },
  { key: 'OTHER', label: 'Other' },
];

export const beneficiaryRelationshipOptions = [
  ...acceptedContactTypesOptions,
  { key: 'SELF', label: 'Employee' },
];

export const beneficiaryTypesOptions = [{ key: 'PERSON', label: 'Person' }];
